import { render, staticRenderFns } from "./PCheckboxGroup.vue?vue&type=template&id=52e36fe0"
import script from "./PCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./PCheckboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports